import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { PropertyManagement } from './pages/PropertyManagement';
import { BusinessFinance } from './pages/BusinessFinance';
import { LegalExpat } from './pages/LegalExpat';
import { Contact } from './pages/Contact';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/about" element={<About data-id="element-6" />} data-id="element-5" />
          <Route path="/services" element={<Services data-id="element-8" />} data-id="element-7" />
          <Route path="/property-management" element={<PropertyManagement data-id="element-10" />} data-id="element-9" />
          <Route path="/business-finance-services" element={<BusinessFinance data-id="element-12" />} data-id="element-11" />
          <Route path="/legal-licensing-expat-services" element={<LegalExpat data-id="element-14" />} data-id="element-13" />
          <Route path="/contact" element={<Contact data-id="element-16" />} data-id="element-15" />
        </Routes>
      </Layout>
    </Router>;
}